import Readings from './Readings';

export default Readings;
